import { render } from "./index.vue?vue&type=template&id=bf8f1680&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bf8f1680&lang=css"
import "./index.vue?vue&type=style&index=1&id=bf8f1680&lang=css"
import "./index.vue?vue&type=style&index=2&id=bf8f1680&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8f1680"]])

export default __exports__